export default class blackoutContentservice {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('blackoutContents/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('blackoutContents', params)
	}

	createEntity(params){
		return this.apiService.callPost('blackoutContents', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('blackoutContents/'+id, params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('blackoutContents/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BlackoutContentService.js